<template>
  <el-row class="register-payments-toolbar">
    <el-col :xs="12" :sm="6" :lg="4">
      <el-input v-model="searchData.load_point" placeholder="Погрузки откуда" />
    </el-col>

    <el-col :xs="12" :sm="6" :lg="4">
      <el-input v-model="searchData.unload_point" placeholder="Погрузки куда" />
    </el-col>

    <el-col :xs="12" :sm="6" :lg="4">
      <el-input v-model="searchData.state_numbers" placeholder="Номер авто" />
    </el-col>

    <el-col :xs="12" :sm="6" :lg="4">
      <el-input v-model="searchData.name" placeholder="Перевозчик" />
    </el-col>

    <el-col :xs="12" :sm="6" :lg="4">
      <el-input v-model="searchData.inn" placeholder="ИНН перевозчика" />
    </el-col>

    <el-col :xs="12" :sm="6" :lg="4">
      <el-select v-model="searchData.in_report" placeholder="Рейсы" clearable>
        <el-option
          v-for="item in flights"
          :key="item.val"
          :label="item.name"
          :value="item.val"
        />
      </el-select>
    </el-col>

    <el-col :xs="12" :sm="6" :lg="4">
      <el-autocomplete
        v-model="searchData.client"
        style="width: 100%"
        :fetch-suggestions="querySearch"
        placeholder="Заказчик"
        :trigger-on-focus="false"
        value-key="name"
        class="client-autocomplete"
        @focus="createClientList"
      />
    </el-col>

    <el-col v-for="i in dateFilters" :key="i.field" :xs="12" :sm="6" :lg="4">
      <el-date-picker
        v-model="searchData[i.field]"
        type="date"
        :placeholder="i.text"
        :picker-options="pickerOpt"
        value-format="yyyy-MM-dd"
      />
    </el-col>

    <el-col :xs="12" :sm="6" :lg="4">
      <el-select v-model="searchData['per-page']" placeholder="Кол-во">
        <el-option
          v-for="item in perPageOptions"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
    </el-col>

    <el-col :xs="12" :sm="6" :lg="4" class="btn-group">
      <el-button type="primary" style="width: 100%" @click="handleSearch">
        Поиск
      </el-button>
      <el-button plain @click="handleClear">Сбросить</el-button>
    </el-col>
    <el-col :xs="12" :sm="6" :lg="4" class="btn-group">
      <div
        v-if="registerMenuItems.length"
        v-click-outside="onClickOutside"
        style="text-align: right"
        class="zv-nav-menu__dropdown"
      >
        <el-button
          plain
          type=""
          icon="el-icon-more"
          @click="visible = !visible"
        />

        <el-collapse-transition>
          <div v-if="visible" class="zv-nav-menu__sidemenu">
            <el-menu
              active-text-color="#2ECC71"
              background-color="#EEEEEE"
              :default-active="activeIndexMenu"
            >
              <template v-for="(item, j) in registerMenuItems">
                <el-menu-item
                  :key="j"
                  :disabled="!showTablePaymentsMenu"
                  :index="item.name"
                  @click="handleClickMenu(item)"
                >
                  {{ item.title }}
                </el-menu-item>
              </template>
            </el-menu>
          </div>
        </el-collapse-transition>
      </div>
      <div v-if="selectedDebt" class="amount">
        <div class="amount__item">К оплате:</div>
        <div class="amount__item">
          <b>{{ formattedSelectedDebt }}</b>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { dateFilters, perPageOptions } from '../constants'
import { mapActions, mapGetters } from 'vuex'
import { pickerOpt } from '@/datas/consts'

import { formattedNumberDecimal } from '@/helpers/functions'
import { registerMenuItems } from '@/views/RegisterOfPayments/constants'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'RegisterOfPaymentsToolbar',
  directives: {
    ClickOutside,
  },
  props: {
    showTablePaymentsMenu: {
      type: Boolean,
      default: false,
    },
    selectedDebt: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      perPageOptions,
      pickerOpt,
      dateFilters,
      visible: false,
      activeIndexMenu: '1',
      registerMenuItems,
      searchData: {
        load_point: '',
        unload_point: '',
        state_numbers: '',
        name: '',
        inn: '',
        in_report: undefined,
        client: '',
        date_from: undefined,
        date_to: undefined,
        'per-page': 5,
      },
      flights: [
        { name: 'в отчете', val: 1 },
        { name: 'без отчета', val: 0 },
      ],
      clients: [],
    }
  },
  computed: {
    ...mapGetters({
      getSearchClientList: 'clients/getList',
    }),

    formattedSelectedDebt() {
      return formattedNumberDecimal(this.selectedDebt)
    },
  },
  created() {
    this.fetchClients({ perPage: 9999 })
  },
  methods: {
    ...mapActions({
      fetchClients: 'clients/fetchClients',
    }),
    createClientList() {
      this.clients = this.getSearchClientList().map(item => ({
        name: item.name,
      }))
    },
    querySearch(queryString, cb) {
      var links = this.clients

      if (queryString.length > 2) {
        var results = links.filter(
          item =>
            item.name.toLowerCase().indexOf(queryString.toLowerCase()) !== -1,
        )

        cb(results)
      }
    },
    handleClickMenu(item) {
      this.$emit('setDialog', item.name)
      this.visible = false
    },
    onClickOutside() {
      this.visible = false
    },
    handleSearch() {
      this.$emit('searchPayments', this.searchData)
    },
    handleClear() {
      this.searchData = {
        load_point: '',
        unload_point: '',
        state_numbers: '',
        name: '',
        inn: '',
        in_report: undefined,
        client: '',
        date_from: undefined,
        date_to: undefined,
        'per-page': 5,
      }
      this.handleSearch()
    },
  },
}
</script>

<style lang="sass">
.register-payments-toolbar
  .el-col
    padding-right: 16px
    margin-bottom: 16px

.el-autocomplete-suggestion
  width: fit-content !important

.el-date-editor--date
  width: 100% !important

.amount
  flex: 1
  margin-left: 10px
  &__item
    text-align: center
</style>
